import React from 'react';
import { Handle, Position } from 'reactflow';
import { FaMagic } from 'react-icons/fa';

const AIActionNode = ({ data, isConnectable }) => {
  const isConfigured = data.config && Object.keys(data.config).length > 0;

  return (
    <div className={`custom-node action-node ${!isConfigured ? 'unconfigured' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="node-handle"
      />
      <div className="node-icon">
        <FaMagic />
      </div>
      <div className="node-content">
        <div className="node-label">{data.label}</div>
        {!isConfigured && <div className="node-status">Not configured</div>}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="node-handle"
      />
    </div>
  );
};

export default AIActionNode;

